import { render, staticRenderFns } from "./TopBarMenu.vue?vue&type=template&id=afa0e9da&scoped=true"
import script from "./TopBarMenu.vue?vue&type=script&lang=js"
export * from "./TopBarMenu.vue?vue&type=script&lang=js"
import style0 from "./TopBarMenu.vue?vue&type=style&index=0&id=afa0e9da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa0e9da",
  null
  
)

export default component.exports